package dev.krno.components

import androidx.compose.runtime.Composable
import dev.krno.data.EventData
import dev.krno.data.Speaker
import org.jetbrains.compose.web.dom.Article
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Speakers(onOpenSpeaker: (Speaker) -> Unit) {
    Section(attrs = {
        id("speakers")
        classes("wrap", "speakers")
        style { property("padding-top", "0") }
    }) {
        Div(attrs = { classes("head") }) {
            Div {
                Div(attrs = {
                    classes("label")
                    style { property("margin-bottom", "14px") }
                }) { Text("Speakers") }
                H2 { Text(speakerHeading(EventData.speakers.size)) }
            }
            P {
                Text(
                    "Working engineers from Brno and around, talking about things they shipped this year."
                )
            }
        }
        Div(attrs = { classes("spk-grid") }) {
            EventData.speakers.forEach { s ->
                SpeakerCard(s, onOpen = { onOpenSpeaker(s) })
            }
            // Compact-only: fills the empty 4th grid cell when there are 3 cards
            // stacked as 2 + 1. Hidden on desktop via CSS. See krno.css.
            CompactCodeSnippet()
        }
    }
}

private fun speakerHeading(n: Int): String = when (n) {
    1 -> "One person, one talk"
    2 -> "Two people, two talks"
    3 -> "Three people, three talks"
    4 -> "Four people, four talks"
    else -> "$n people, $n talks"
}

@Composable
private fun SpeakerCard(s: Speaker, onOpen: () -> Unit) {
    Article(attrs = {
        classes("spk")
        attr("role", "button")
        attr("tabindex", "0")
        attr("aria-label", "Open details for ${s.name.ifEmpty { "speaker" }}")
        onClick { onOpen() }
        onKeyDown { evt ->
            val key = evt.asDynamic().key as? String
            if (key == "Enter" || key == " ") {
                evt.preventDefault()
                onOpen()
            }
        }
    }) {
        Div(attrs = { classes("photo") }) {
            if (s.photo.isNotEmpty()) {
                Img(src = s.photo, attrs = {
                    classes("spk-photo-img")
                    attr("alt", s.name)
                })
            } else {
                Span { Text("speaker photo") }
            }
        }
        H3 { Text(s.name) }
        Div(attrs = { classes("role") }) { Text(s.role) }
        P(attrs = { classes("talk") }) { Text(s.talk) }
    }
}
